import React from "react";
import CountUp from "react-countup";

const BydSealionHome = () => {
  return (
    <section className="fluid bg-light-gray-1">
      <div id="sealion7-banner">
        <div className="box-container">
          <div className="seal-box">
            <div className="box-content">
              <div className="box-countup">
                ₹ {""}
                <CountUp
                  start={0}
                  end={50.6}
                  duration={3}
                  decimals={2}
                  redraw={true}
                />{" "}
                Lakh
              </div>
              <div className="subContent">Starting Price* (Ex-Showroom)</div>
            </div>
          </div>
          <div className="seal-box">
            <div className="box-content">
              <div className="box-countup">
                <CountUp
                  start={0}
                  end={567}
                  duration={5}
                  decimals={0}
                  redraw={true}
                />{" "}
                km
              </div>
              <div className="subContent">Top driving Range*</div>
            </div>
          </div>
          <div className="seal-box">
            <div className="box-content">
              <div className="box-countup">
                <CountUp
                  start={0}
                  end={4.5}
                  duration={5}
                  decimals={1}
                  redraw={true}
                />
                s
              </div>
              <div className="subContent">0-100 km/h*</div>
            </div>
          </div>
          <div className="seal-box">
            <div className="box-content">
              <div className="box-countup">
                <CountUp
                  start={0}
                  end={82.56}
                  duration={3}
                  decimals={2}
                  redraw={true}
                />{" "}
                kWh
              </div>
              <div className="subContent">Battery capacity*</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BydSealionHome;
